class PaginationButton {
    constructor(buttonElem) {
        this.elem = buttonElem;
        this.loadMoreTextElem = buttonElem.getElementsByClassName('load-more-text');
    }

    nextPage() {
        return parseInt(this.elem.getAttribute('data-next-page'), 10);
    }

    incrementNextPage(load_more_text) {
        if (this.loadMoreTextElem.length) {
            this.loadMoreTextElem[0].innerText = load_more_text || '';
        }
        this.elem.setAttribute('data-next-page', this.nextPage() + 1);
    }

    resetNextPage() {
        this.elem.setAttribute('data-next-page', 2);
    }

    setLoading() {
        this.elem.setAttribute('disabled', '');
    }

    setUnloading() {
        this.elem.removeAttribute('disabled');
    }

    hide() {
        this.elem.style.display = 'none';
    }

    show() {
        this.elem.style.display = 'unset';
    }
}

function getResource(nextPage) {
    const resource = new URL(window.location.href);
    resource.searchParams.append('page', nextPage);
    return resource;
}

function appendPage(listingElem, newPageHTML) {
    if (newPageHTML !== undefined) {
        listingElem.insertAdjacentHTML('beforeend', newPageHTML);
    }
}

function setButtonRenderState(button, listingElem) {
    const morePages = document.querySelector('[data-last-page]') === null;
    if (morePages && listingElem.children.length > 0) {
        button.setUnloading();
        button.show();
    } else {
        button.hide(); // no more pages to load
    }
}

function loadNextPage(listingElem, loadMoreButton) {
    fetch(
        getResource(loadMoreButton.nextPage()),
        { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
    )
        .then((response) => {
            if (response.status === 200) {
                return response.text();
            }
        })
        .then((html) => {
            appendPage(listingElem, html);
            const parser = new DOMParser();
            const newList = parser.parseFromString(html, 'text/html');
            const load_more_text = newList.querySelector('[data-load-more-string]')?.dataset?.loadMoreString;
            const loadMoreButtonElem = document.querySelector('[data-next-page]');
            const allMorePages = document.querySelectorAll('[data-more-pages]');

            loadMoreButton.incrementNextPage(load_more_text);
            if (allMorePages.length > 0) {
                const lastMorePages = allMorePages[allMorePages.length - 1];
                const morePages = lastMorePages?.dataset?.morePages;
                if (morePages === 'False') loadMoreButtonElem.style.visibility = 'hidden';
            } else {
                loadMoreButtonElem.style.visibility = 'visible';
            }
        });
}

function setup(listingElem) {
    const loadMoreButtonElem = document.querySelector('[data-next-page]');
    if (loadMoreButtonElem) {
        // console.log(loadMoreButtonElem);
        const loadMoreButton = new PaginationButton(loadMoreButtonElem);

        // setup pagination event handler
        if (loadMoreButton !== null) {
            loadMoreButton.elem.addEventListener('click', (e) => {
                e.preventDefault();
                loadMoreButton.setLoading();
                loadNextPage(listingElem, loadMoreButton);
            });
        }

        // fire to set correct initial button state
        setButtonRenderState(loadMoreButton, listingElem);

        // set initial load more text
        if (loadMoreButton.loadMoreTextElem.length) {
            const load_more_text = document.querySelector('[data-load-more-string]')?.dataset?.loadMoreString;
            loadMoreButton.loadMoreTextElem[0].innerText = load_more_text;
        }

        // setup listener for any other modifications to the listing table by others.
        // eslint-disable-next-line no-inner-declarations
        function handleListingChange(mutationList, observer) {
            mutationList.forEach(mutation => {
                switch (mutation.type) {
                case 'childList':
                    if (mutation.removedNodes.length > 0) {
                        // we assume the listing content was reset, so we reset the page counter
                        loadMoreButton.resetNextPage();
                    }
                }
            });
            // we assume that anything else modifying the listing table is doing so
            // in a way that resets the page count.
            setButtonRenderState(loadMoreButton, listingElem);
        }

        const observer = new MutationObserver(handleListingChange);
        observer.observe(listingElem, { childList: true });
    }
}

export default function init(listingElem) {
    setup(listingElem);
}
